module.exports = __webpack_public_path__ + "96CDE27BE6A761F15653E5A1B5B5BF91SocialLinks.8e519d57.png";